import React from 'react'
import { useModalDisableScroll } from 'helpers/hooks'
import './RoadmapModal.css'

export default function RoadmapModal({ children, shown, close }) {
    useModalDisableScroll(shown)

    return shown ? (
        <div
            className="roadmapmodal-backdrop"
            onClick={() => {
                close()
            }}
        >
            <div
                className="roadmapmodal-content"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className="roadmapmodal__text">
                    <h1>the roadmap</h1>
                    <ul className="roadmapmodal__list">
                        <li>
                            <h2>Q1 2022</h2>
                            <br />- Launch{' '}
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://drive.google.com/file/d/1GG4uVWsm8FGWZIr2ahifcz7_6G7f-ppu/view"
                            >
                                The NBD Brownpaper
                            </a>
                            <br />- Launch of Natural Born Degenz Website
                            <br />- Sale, Rarity, and Staking of Lunicorn 🦄
                            <br />- Determine tokenomics, $NGMI supply model,
                            and setup $NGMI staking
                            <br />- Revamp Discord & Engagement strategy
                        </li>
                        <li>
                            <h2>Q2 2022</h2>
                            <br />- Display art from the NBD Wallet in the
                            metaverse
                            <br />- Distribute «The Carrot» 👀 to Lunicorn
                            holders
                            <br />- Sale of «The Gullible Seagulls» 🦅
                            <br />- Setup staking of «The Gullible Seagulls»
                            <br />- Introduce «The Wangmies» 👾
                        </li>
                        <li>
                            <h2>Q3-Q4 2022</h2>
                            <br />- Launch «The Degen Exchange»
                            <br />- Introduce Degenz Incubator Club (DIC)
                            <br />- Sale of «The Wangmies»
                            <br />- Explore idea of a Degenverse and Degenz game
                            <br />- Explore opportunity of making a real world
                            Degen Fuel with @Elrond Energy
                        </li>
                        <button
                            onClick={() => {
                                close()
                            }}
                            className="okButtonRoadmap"
                        >
                            OK
                        </button>
                    </ul>
                </div>
            </div>
        </div>
    ) : null
}
